module.exports = __webpack_public_path__ + "static/media/ing2.8057be59.jpg";